export enum IntegrationProvider {
  None,
  Fiskaly,
}
